// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2WlBz","buttons":"Footer_buttons__2giND"};